import { RadioChangeEvent, Space } from 'antd';
import { DatePicker, Form, Radio, Select } from '@maxtropy/components';
import dayjs, { Dayjs } from 'dayjs';
import { FC, useEffect, useState, useMemo } from 'react';
import { getDataQueryPeriodList } from '@/api/energyOverview';
import styles from '../index.module.scss';
import { overallGetTime, OnDateTypeDisplay, DateType } from '../../utils';
import useLatestRequest from '../../useLatestRequest';

export interface DateSwitchProps {
  isDeviceperiod: boolean;
  isIndicatorperiod: boolean;
  compareType: string;
  onQueryChange?: (value: {
    timeResolution: string;
    fromAndTo: number[];
    dataQueryPeriodId?: number | undefined;
  }) => void;
}

const DateSwitch: FC<DateSwitchProps> = props => {
  const { onQueryChange, isIndicatorperiod, isDeviceperiod, compareType } = props;
  const [timeResolution, setTimeResolution] = useState<DateType>(DateType.DAY);
  const [dateRange, setDateRange] = useState<Dayjs>(dayjs());
  const [dataPeriodList, setDataPeriodList] = useState<any[]>([]);
  const [form] = Form.useForm();
  const { runLatest } = useLatestRequest();
  const fromAndTo = useMemo(() => {
    const { startTime, endTime } = overallGetTime(timeResolution, dateRange);
    return [startTime, endTime];
  }, [timeResolution, dateRange]);

  useEffect(() => {
    form.setFieldValue('dataQueryPeriodId', undefined);
    setDataPeriodList([]);

    onQueryChange?.({
      timeResolution,
      fromAndTo,
    });

    runLatest(() => getDataQueryPeriodList({ startTime: fromAndTo[0], endTime: fromAndTo[1] }), {
      onSuccess: res => setDataPeriodList(res.dataPeriodList ?? []),
    });
  }, [compareType, form, fromAndTo, onQueryChange, runLatest, timeResolution]);

  const onRadioChange = (e: RadioChangeEvent) => {
    const value: DateType = e.target.value;
    setTimeResolution(value);
    setDateRange(dayjs());
  };

  const disabledDate = (current: Dayjs) => {
    return current && current >= dayjs().endOf('day');
  };

  const picker = useMemo(() => {
    if (timeResolution === DateType.MONTH) {
      return 'month';
    } else if (timeResolution === DateType.WEEK) {
      return 'week';
    } else if (timeResolution === DateType.YEAR) {
      return 'year';
    } else {
      return 'date';
    }
  }, [timeResolution]);
  return (
    <Space className={styles.dateSwitch} size={16}>
      <Space>
        <Radio.Group onChange={onRadioChange} value={timeResolution} buttonStyle="solid">
          <Radio.Button value={DateType.DAY}>{OnDateTypeDisplay[DateType.DAY]}</Radio.Button>
          <Radio.Button value={DateType.WEEK}>{OnDateTypeDisplay[DateType.WEEK]}</Radio.Button>
          <Radio.Button value={DateType.MONTH}>{OnDateTypeDisplay[DateType.MONTH]}</Radio.Button>
          {/* <Radio.Button value={DateType.YEAR}>{OnDateTypeDisplay[DateType.YEAR]}</Radio.Button> */}
        </Radio.Group>

        <DatePicker
          picker={picker}
          value={dateRange}
          disabledDate={disabledDate}
          onChange={setDateRange}
          style={{ width: 190 }}
          allowClear={false}
        />
      </Space>
      <Space>
        {(isIndicatorperiod || isDeviceperiod) && (
          <Form isOrigin={true} form={form}>
            <Form.Item name="dataQueryPeriodId" label="数据查询时段" style={{ marginBottom: 0 }}>
              <Select
                placeholder="请选择"
                style={{ width: 150 }}
                onChange={(value: number) => {
                  onQueryChange?.({
                    timeResolution,
                    fromAndTo,
                    dataQueryPeriodId: value,
                  });
                }}
                options={dataPeriodList.map(item => ({ value: item.id, label: item.name }))}
                allowClear
              />
            </Form.Item>
          </Form>
        )}
      </Space>
    </Space>
  );
};

export default DateSwitch;
